import { Inject } from 'inversify-props'
import type { VendaServiceAdapter } from './adapter'
import { ItemDaVenda, Page, ResumoDaVenda, Venda, VendaComReferencias, VendaDemonstracaoResumida, 
	DadosParaReaberturaMultiplaDeVendas, PedidoListagem, AvaliacaoNps, AvaliacaoNpsResposta, GavetaDeDemonstracao } from '@/models'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { OfertaRelacionadaDoProduto } from '@/models/venda/OfertaRelacionadaDoProduto'

export class FindVendaUseCase {
	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Venda>> =>
		await this.vendaService.find(params, config)

	list = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ResumoDaVenda>> =>
		await this.vendaService.listVendas(params, config)

	listVendasSemTurno = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ResumoDaVenda>> =>
		await this.vendaService.listVendasSemTurno(params, config)

	findNumeroDePedidos = async (params?: any, config?: AxiosRequestConfig): Promise<string> =>
		await this.vendaService.findNumeroDePedidos(params, config)

	get = async (id: string): Promise<Venda> =>
		await this.vendaService.get(id)

	getVendaComReferencias = async (id: string): Promise<VendaComReferencias> =>
		await this.vendaService.getVendaComReferencias(id)

	listNota = async (params?: any, config?: AxiosRequestConfig): Promise<Page<ResumoDaVenda>> =>
		await this.vendaService.listNota(params, config)

	buscarOrigem = async (produtoId: string, quantidadeLida: number, lojaId: string, cpfOuCnpjCliente: string, itens: ItemDaVenda[]): Promise<ItemDaVenda> =>
		await this.vendaService.buscarOrigem(produtoId, quantidadeLida, lojaId, cpfOuCnpjCliente, itens)

	findVendaByNota = async (chaveNF: string): Promise<string> =>
		await this.vendaService.findVendaByNota(chaveNF)
	buscarVendasParaRetornoMultiplo = async (cpfOuCnpjCliente: string, lojaId: string, retornoMultiploDeDemonstracao: boolean): Promise<DadosParaReaberturaMultiplaDeVendas[]> =>
		await this.vendaService.buscarVendasParaRetornoMultiplo(cpfOuCnpjCliente, lojaId, retornoMultiploDeDemonstracao)

	findHierarquiaDemonstracoes = async (params?: any, config?: AxiosRequestConfig): Promise<Page<VendaDemonstracaoResumida>> =>
		await this.vendaService.findHierarquiaDemonstracoes(params, config)

	validarItensDemonstracaoCliente = async (params: any, cpfCliente: string, grupoEconomicoId: string): Promise<void> =>
		await this.vendaService.validarItensDemonstracaoCliente(params, cpfCliente, grupoEconomicoId)
	
	possuiDevolucaoDaVendaOrigem = async (vendaOrigemIds: string[]): Promise<boolean> =>
		await this.vendaService.possuiDevolucaoDaVendaOrigem(vendaOrigemIds)

	imprimirMultiplosCupons = async (vendaIds: string[]): Promise<AxiosResponse<Blob>> =>
		await this.vendaService.imprimirMultiplosCupons(vendaIds)

	findPedidosListagemByFiltrosOtimizado = async (params?: any, config?: AxiosRequestConfig): Promise<PedidoListagem[]> =>
		await this.vendaService.findPedidosListagemByFiltrosOtimizado(params, config)

	relacionaVendaEPedidoDaVitrine = async (vendaId: string, vendaVitrineId: string): Promise<void> =>
		await this.vendaService.relacionaVendaEPedidoDaVitrine(vendaId, vendaVitrineId)

	findByIdentificadorSimple = async (identificador: string): Promise<Venda> =>
		await this.vendaService.findByIdentificadorSimple(identificador)

	gerarLinkDeAvaliacaoNps = async (identificador: string, link: string): Promise<AvaliacaoNps> =>
		await this.vendaService.gerarLinkDeAvaliacaoNps(identificador, link)

	enviarAvaliacaoNpsParaWhatsappDoCliente = async (id: string): Promise<void> =>
		await this.vendaService.enviarAvaliacaoNpsParaWhatsappDoCliente(id)

	criaAvaliacaoNpsRespostaDoCliente = async (avaliacaoId: string, respostas: AvaliacaoNpsResposta[], vendedorId: string) =>
		await this.vendaService.criaAvaliacaoNpsRespostaDoCliente(avaliacaoId, respostas, vendedorId)
	
	findOfertaRelacionadaDoProduto = async (skuPai: string, skusNoCarrinho: string[]): Promise<OfertaRelacionadaDoProduto[]> =>
		await this.vendaService.findOfertaRelacionadaDoProduto(skuPai, skusNoCarrinho)

	findGavetasDeDemonstracoes = async (params?: any): Promise<Page<GavetaDeDemonstracao>> =>
		await this.vendaService.findGavetasDeDemonstracoes(params)

	countGavetasDeDemonstracaoEmAberto = async (params?: any): Promise<number> =>
		await this.vendaService.countGavetasDeDemonstracaoEmAberto(params)
}
